import React, { useEffect, useState } from "react";
import { useGetProjectDetails } from "../../../../../queries/query-hooks/workspace/workspace-hook";
import { useParams } from "react-router-dom";
import CommentCard from "../components/CommentCard";
import { Card } from "react-bootstrap";
import CommentSkeleton from "../../../../../skeleton/workspace/clirnet/sponsored-community/CommentSkeleton";
import InfiniteScroll from "react-infinite-scroll-component";
import axiosInstance from "../../../../../api/instances/axiosInstance";
import app_config from "../../../../../common/data/app_config";
import { ProjectHeaderTopBar, TextAndDateFilter, CardNotFound } from "@ui";

const Comments = () => {
  const { project_id } = useParams();
  const { data: projectDetails, isLoading: isProjectDetailsLoading } =
    useGetProjectDetails(project_id, true);
  const [dateRangePayload, setDateRangePayload] = useState({
    start_date: "",
    end_date: "",
  });
  const [searchInputText, setSearchInputText] = useState("");
  const [filterText, setFilterText] = useState("");
  const [isCommentsLoading, setIsCommentsLoading] = useState(true);
  const [commentsList, setCommentsList] = useState([]);
  const [hasMore, sethasMore] = useState(true);
  const [offSet, setOffSet] = useState(0);

  useEffect(() => {
    setOffSet(0);
    setCommentsList([]);
    sethasMore(true);
    fetchComments();
  }, [project_id, dateRangePayload, filterText]);

  async function fetchComments() {
    try {
      if (offSet === 0) {
        setIsCommentsLoading(true);
      }
      if (!!dateRangePayload.start_date && !!dateRangePayload.end_date) {
        const response = await axiosInstance.post(
          `${app_config.api_url}/project/${project_id}/channel-reporting/comments/info`,
          {
            from: 0,
            to: 10,
            offset: offSet,
            limit: 10,
            start_date: dateRangePayload.start_date,
            end_date: dateRangePayload.end_date,
            query: filterText,
          }
        );

        const fetchedData = response?.data?.data ?? [];

        if (offSet === 0) {
          setCommentsList(fetchedData);
        } else {
          setCommentsList((prev) => [...prev, ...fetchedData]);
        }

        if (fetchedData.length > 0) {
          setOffSet(offSet + 10);
          sethasMore(true);
        } else {
          sethasMore(false);
        }
        setIsCommentsLoading(false);
      }
    } catch (e) {
      console.log(e);
      setIsCommentsLoading(false);
    }
  }

  const onSearchFilterTextHanlder = (e) => {
    if (e.key === "Enter") {
      setOffSet(0);
      setCommentsList([]);
      sethasMore(true);
      setFilterText(searchInputText);
    }
  };

  return (
    <div>
      <div className="mb-3">
        <ProjectHeaderTopBar
          projectType="CLIRNET Channel"
          title="Comments"
          projectStartDate={projectDetails?.at(0)?.project_start_date || ""}
          projectEndDate={projectDetails?.at(0)?.project_end_date || ""}
          status={projectDetails?.at(0)?.project_status}
          isProjectDetailsLoading={isProjectDetailsLoading}
        />
      </div>

      <TextAndDateFilter
        searchText="Search for content"
        filterText="Select date for comments"
        searchInputText={searchInputText}
        setSearchInputText={setSearchInputText}
        onSearchFilterTextHanlder={onSearchFilterTextHanlder}
        setDateRangePayload={setDateRangePayload}
        dateLabel={dateRangePayload}
      />

      <p className="m-0 px-3 py-2">Comments</p>

      <Card className="mb-3">
        {!isCommentsLoading && commentsList?.length > 0 ? (
          <InfiniteScroll
            dataLength={commentsList?.length ?? 0}
            hasMore={hasMore}
            next={() => {
              fetchComments();
            }}
            loader={<p className="text-center">Loading...</p>}
          >
            {commentsList?.map((item, index) => {
              return <CommentCard key={item?.content_id} item={item} />;
            })}
          </InfiniteScroll>
        ) : isCommentsLoading ? (
          [...Array(5)].map((_, index) => <CommentSkeleton key={index} />)
        ) : (
          <CardNotFound height={320} />
        )}
      </Card>
    </div>
  );
};

export default Comments;
